// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"42957c29","946":"6856a6e6"}[chunkId] + ".chunk.js";
};